<template>
  <div class="mt-2">
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div>
        <b-table
          :busy="isLoading"
          head-variant="light"
          :no-local-sorting="true"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
          @sort-changed="sortingChanged"
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newDocsNoMatchBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea un
                  nuovo Documento non abbinato cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewDocNoMatch"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea
                </b-button
                >
              </div>
            </template>
            <template v-else>
              <empty-table
                :isTableInModal="isTableInModal"
                :performedSearch="performedSearch"
                :automaticPerformedSearch="automaticPerformedSearch"
                :filterCount="filterCount"
              />
            </template>
          </template>
          <template #cell(category)="row">
            {{ row.item?.categories?.[0]?.title }}
          </template>
          <template #cell(customer)="row">
            {{
              row.item["registries"]
                ? row.item?.registries?.[0]?.title
                : row.item?.insurance_policies?.[0]?.registry?.title
            }}
          </template>
          <template #cell(tax_code)="row">
            <span
              v-if="row.item['registries']"
              v-html="
                toRelationString('registries', row.item.registries, ['NINO'])
              "
            ></span>
            <span v-else>
              {{
                row.item?.insurance_policies?.[0]?.registry?.attributables.NINO
              }}
            </span>
          </template>
          <template #cell(piva)="row">
            <span
              v-if="row.item['registries']"
              v-html="
                toRelationString('registries', row.item.registries, ['CREG'])
              "
            ></span>
            <span v-else>
              {{
                row.item?.insurance_policies?.[0]?.registry?.attributables.CREG
              }}
            </span>
          </template>
          <template #cell(insurance_policy_number)="row">
            {{ row.item?.insurance_policies?.[0]?.number }}
          </template>
          <template #cell(insurer)="row">
            {{ row.item?.insurance_policies?.[0]?.insurer?.title }}
          </template>
          <template #cell(plate)="row">
            <span
              v-html="
                toRelationString(
                  'insurance_policies',
                  row.item.insurance_policies,
                  ['REPL']
                )
              "
            ></span>
          </template>
          <template #cell(download)="row">
            <div class="action-buttons">
            <b-button
              size="sm"
              variant="lisaweb"
              class="mt-1 mr-1"
              :title="`Scarica documento ${row.item.title}`"
              @click="downloadDocument(row.item)"
            >
              <base-icon name="download" width="22"></base-icon>
            </b-button>
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>

              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash"></base-icon>
              </b-button>
            </div>
          </template>
          <template #row-details="row">
            <b-card>
              <b-row
                class="mb-2"
                v-for="(value, key) in customized(row.item)"
                :key="key"
              >
                <b-col sm="3" class="text-sm-right"
                ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>
      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
          <span :data-active="active">{{
              page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            }}</span>
              </template>
              <template v-slot:first-text>
          <span
          ><base-icon
            scale="-1"
            name="chevron_right_last_rounded"
            width="16"
            height="16"
          /></span>
              </template>
              <template v-slot:prev-text>
          <span
          ><base-icon
            scale="-1"
            name="chevron_right_rounded"
            width="16"
            height="16"
          /></span>
              </template>
              <template v-slot:next-text>
          <span
          ><base-icon
            name="chevron_right_rounded"
            width="16"
            height="16"
          /></span>
              </template>
              <template v-slot:last-text>
          <span
          ><base-icon
            name="chevron_right_last_rounded"
            width="16"
            height="16"
          /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
        totalItems && !noInputPaginator && totalPages && totalPages > 3
      "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>

      <b-modal
        :id="infomodalName"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
        scrollable
        ok-only
        ok-title="Chiudi"
        ok-variant="-transparent"
      >
        <template v-slot:modal-header-close>
          <base-icon name="close" width="14" height="14"/>
        </template>
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab></button-group-tab>

              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="fetch"
                  :dbRowData="dbRowData"
                  :modalName="infomodalName"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import General from "@/components/documents/no-match/details/General";
import BaseInputPagination from "../form/BaseInputPagination.vue";
import EmptyTable from "@/components/EmptyTable.vue";

export default {
  name: "DocumentsNoMatchTable",
  extends: template,
  data() {
    return {
      tabs: [{name: "General", text: "Generale"}],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
      dbRowData: null,
    };
  },
  components: {
    BaseInputPagination,
    BaseIcon,
    ButtonGroupTab,
    General,
    EmptyTable,
  },
  methods: {
    downloadDocument(item) {
      this.$emit("download", item);
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    customized(item) {
      let c = {};
      c.descrizione = item.description;
      c.titolo = item.title;
      return c;
    },
  },
  props: {
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    performedSearch: {
      type: Boolean,
      default: false,
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    newDocsNoMatchBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  }
};
</script>